import '/node_modules/waypoints/lib/jquery.waypoints.min.js';
import "/components/counting-numbers/assets/jquery.countup.min.js";

jQuery(document).ready(function ($) {

	$('.counter').countUp();

});
